module.exports = {"title":"What People Are Saying","quotes":[{"text":"...","cite":"Tom, Hertfordshire"},{"text":"...","cite":"Louise, Pembrokeshire"}]}